// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__AiSQc","content":"GlobalSearch_content__28O50"};